export enum LocalStorage {
  GCLID_PARAMETERS = `gclid`,
  UTM_PARAMETERS = `utm-parameters`,
  COOKIE_STORAGE_ID = `nester-cookies-accept`,
}
